import { SolvTheme, Stack, Text } from '@solvhealth/jigsaw-v1';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { BookColdAndCoughTreatment } from '~/components/AccountGetsMarried/components/GetCare/components/NavTiles/components/BookColdAndCoughTreatment';
import BookCovidTest from '~/components/AccountGetsMarried/components/GetCare/components/NavTiles/components/BookCovidTest';
import { BookFallAllergyTreatment } from '~/components/AccountGetsMarried/components/GetCare/components/NavTiles/components/BookFallAllergyTreatment';
import BookFluShot from '~/components/AccountGetsMarried/components/GetCare/components/NavTiles/components/BookFluShot';
import { biggerThanOrEqualTo } from '~/core/util/styledComponents';

const Content = styled.div.withConfig({ componentId: 'sc-agb5a4-0' })`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${biggerThanOrEqualTo.sm`
    display: grid;
    grid-gap: 24px;
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: minmax(100px, auto);
    padding-left: 24px;
    padding-right: 24px;
    max-width: ${SolvTheme.breakpoints.lg};
    margin: 0 auto;
    box-sizing: border-box;
  `}

  ${biggerThanOrEqualTo.lg`
    grid-template-columns: repeat(4, 1fr);
  `}
`;

type Props = {
  userProfileId: string;
};
export const SeasonalServices = ({ userProfileId }: Props) => {
  // current season (fall, winter, spring, summer) is determined by the month
  const currentSeason = useMemo(() => {
    const today = new Date();
    const month = today.getMonth();
    switch (true) {
      case (month >= 0 && month <= 1) || month === 11:
        return 'winter';
      case month >= 2 && month <= 4:
        return 'spring';
      case month >= 5 && month <= 7:
        return 'summer';
      case month >= 8 && month <= 10:
        return 'fall';
      default:
        return 'seasonal';
    }
  }, []);

  return (
    <Stack space={2} width="100%">
      <Text maxWidth={SolvTheme.breakpoints.lg} mx="auto" px={3} variant="h3" width="100%">
        Essential {currentSeason} services
      </Text>
      <Content>
        {['winter', 'fall'].includes(currentSeason) && (
          <BookFluShot userProfileId={userProfileId} />
        )}
        {['winter', 'summer', 'spring'].includes(currentSeason) && <BookCovidTest />}
        {['fall'].includes(currentSeason) && <BookFallAllergyTreatment />}
        <BookColdAndCoughTreatment />
      </Content>
    </Stack>
  );
};
